import { toast, ToastOptions, ToastContent } from 'react-toastify';

export interface Orderable {
  data: () => {
    orderIndex: number;
  };
}

// eslint-disable-next-line
export const appSort = (left: Orderable, right: Orderable) => left.data().orderIndex - right.data().orderIndex;

// eslint-disable-next-line
export const toasts = (() => {
  const defaultOptions: ToastOptions = { type: toast.TYPE.DEFAULT, position: toast.POSITION.BOTTOM_CENTER };

  // eslint-disable-next-line
  const notify = (content: ToastContent, options?: ToastOptions) => {
    toast(content, { ...defaultOptions, ...options });
  };

  return {
    // eslint-disable-next-line
    info(message: string) {
      notify(message, { type: toast.TYPE.INFO });
    },
    // eslint-disable-next-line
    success(message: string) {
      notify(message, { type: toast.TYPE.SUCCESS });
    },
    // eslint-disable-next-line
    warning(message: string) {
      notify(message, { type: toast.TYPE.WARNING });
    },
    // eslint-disable-next-line
    error(message: string) {
      notify(message, { type: toast.TYPE.ERROR });
    },
    // eslint-disable-next-line
    default(message: string) {
      notify(message, { type: toast.TYPE.DEFAULT });
    },
  };
})();
